import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThirdwebProvider } from "@thirdweb-dev/react";
import { BrowserRouter } from "react-router-dom";
// Importar configuración de i18n
import './config/i18n';
import './styles/index.css';
// import './styles/components.css';
import './styles/transitions.css';
import './styles/connect-wallet.css'; // Importar los estilos para el componente ConnectWallet
import './styles/background.css'; // Importar último para darle prioridad

// Configuración de la cadena BSC Testnet
const activeChain = {
  chainId: 97,
  rpc: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18,
  },
  shortName: "bscTestnet",
  slug: "bsc-testnet",
  testnet: true,
  chain: "Binance Smart Chain Testnet",
  name: "BSC Testnet"
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThirdwebProvider 
      activeChain={activeChain}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThirdwebProvider>
  </React.StrictMode>
);
